import React from 'react';
import { Text, Group, Rect } from 'react-konva';

const fontSize = 15;

const Coefficients = ({ text, color, xPosition, yPosition, elemHeight, elemWidth, isHighlighted, textColor }) => {
    return (
        <Group x={xPosition} y={yPosition}>
            <Rect 
                fill={color}
                cornerRadius={5}
                x={0}
                y={0}
                height={elemHeight}
                width={elemWidth}
                shadowEnabled={isHighlighted}
                shadowBlur={25}
                shadowOffsetX = {0}
                shadowOffsetY = {0}
                shadowOpacity = {1}
                shadowColor = {color}
            />
            <Text
                align='center'
                text={text}
                fontSize={fontSize}
                fontStyle='bold'
                fill={textColor}
                width={elemWidth}
                verticalAlign='center'
                y={elemHeight/2 - fontSize / 2}
            />
        </Group>
    );

};

export default Coefficients;